import React from 'react';
import {
    AppBar,
    Button,
    createStyles,
    makeStyles,
    Theme,
    Typography,
} from '@material-ui/core';
import Toolbar from '@material-ui/core/Toolbar';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { DesktopAppBar } from '../DesktopAppBar';

type BackAppBarProps = {
    children?: React.ReactNode,
    title: string,
    onBackClick?: () => void,
};

BackAppBar.defaultProps = {
    children: null,
    onBackClick: undefined,
};

const useStyles = makeStyles((theme: Theme) => createStyles({
    backButtonContainer: {
        height: 32,
    },
    backButton: {
        fontSize: 18,
        marginRight: theme.spacing(2),
    },
    backText: {
        marginLeft: theme.spacing(1),
    },
    toolbar: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(2),
    },
    title: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(2),
        flexGrow: 1,
    },
    mobileAppBar: {
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    },
    desktopAppBar: {
        display: 'none',
        [theme.breakpoints.up('lg')]: {
            display: 'block',
        },
    },
}));

function BackAppBar(props: BackAppBarProps): React.ReactElement {
    const {
        children,
        title,
        onBackClick = BackAppBar.defaultProps.onBackClick,
    } = props;
    const classes = useStyles();

    return (
        <>
            <AppBar className={classes.mobileAppBar} position="sticky">
                <Toolbar className={classes.toolbar}>
                    {onBackClick ? (
                        <div className={classes.backButtonContainer}>
                            {onBackClick ? (
                                <Button
                                    className={classes.backButton}
                                    color="inherit"
                                    onClick={onBackClick}
                                >
                                    <Icon icon={faArrowLeft} />
                                    <Typography className={classes.backText}>回上一頁</Typography>
                                </Button>
                            ) : null}
                        </div>
                    ) : null}
                    <Typography className={classes.title} variant="h5" noWrap>
                        {title}
                    </Typography>
                </Toolbar>
                <div style={{ backgroundColor: '#FFFFFF' }}>
                    {children}
                </div>
            </AppBar>
            <DesktopAppBar className={classes.desktopAppBar}>
                <div style={{ backgroundColor: '#FFFFFF' }}>
                    {children}
                </div>
            </DesktopAppBar>
        </>
    );
}

export { BackAppBar };
